import api from '../axios'


export default {
  login: (payload) => api.post('/landlord/login', payload),
  logout: () => api.put('/landlord/logout'),
  getCurrentUser: () => api.get('/landlord/user/get-current'),
  getPermissions: () => api.get('/landlord/user/get-current-permissions'),
  verify2FA: (payload, staff_id) => api.put(`/landlord/2fa/${staff_id}/validate-2fa`, payload),
}
